import { navigationNamespace } from "@/store/modules/navigation";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({})
export default class ExternalLink extends Vue {
  @Prop(String)
  href!: string;

  @Action("logLinkClickToServer", navigationNamespace)
  logLinkClickToServer!: Function;

  @Getter("inWrapper", navigationNamespace)
  inWrapper!: boolean;

  @Action("externalLink", navigationNamespace)
  externalLink!: Function;

  handleNavigation() {
    this.saveLink();
    if (!this.inWrapper) window.open(this.href, "_blank");
    else {
      let link = this.href;
      if (this.href.endsWith(".pdf")) {
        link = window.origin + "/" + link;
      }
      this.externalLink(link);
    }
  }

  async saveLink() {
    this.logLinkClickToServer(this.href);
  }
}
